import React from 'react';
import PropTypes from 'prop-types';
import AvatarModule from '../AvatarModule';

import { LayoutTeam, ItemTeam } from './style';

const OurTeamLayout = ({ className, dataTeam }) => (
  <div className={className}>
    {dataTeam && (
      <LayoutTeam numItem={dataTeam.length}>
        {dataTeam.map((item, i) => (
          <ItemTeam key={`${item.person + item.job + i}`}>
            <AvatarModule
              person={item.person}
              lastname={item.lastname}
              job={item.job}
              pathImage={item.image}
              phone={item.phone}
              email={item.email}
              userId={String(item.userId)}
              avatarPhoto={item.avatarPhoto}
            />
          </ItemTeam>
        ))}
      </LayoutTeam>
    )}
  </div>
);

OurTeamLayout.propTypes = {
  className: PropTypes.string,
  dataTeam: PropTypes.arrayOf(
    PropTypes.shape({
      person: PropTypes.string,
      job: PropTypes.string
    })
  )
};

export default OurTeamLayout;
